'use client';
import React from 'react';
import { hasCookie, setCookie } from 'cookies-next/client';
import { useRouter } from 'next/navigation';

declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void;
    }
}

export const CookiesConsent: React.FC<{
    translation: { [key: string]: string };
}> = ({ translation }) => {
    const router = useRouter();
    const [showConsent, setShowConsent] = React.useState(false);

    React.useEffect(() => {
        setShowConsent(
            !hasCookie(`${process.env.NEXT_PUBLIC_SITE_REF}-consent`),
        );
    }, []);

    const updateGtagConsent = (consent: boolean) => {
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('consent', 'update', {
                ad_storage: consent ? 'granted' : 'denied',
                analytics_storage: consent ? 'granted' : 'denied',
            });
        }
    };

    const acceptCookie = () => {
        setShowConsent(false);
        setCookie(`${process.env.NEXT_PUBLIC_SITE_REF}-consent`, 'true', {
            maxAge: 60 * 60 * 24 * 28,
        });
        updateGtagConsent(true);
        router.refresh();
    };

    const declineCookie = () => {
        setShowConsent(false);
        setCookie(`${process.env.NEXT_PUBLIC_SITE_REF}-consent`, 'false', {
            maxAge: 60 * 60 * 24 * 1,
        });
        updateGtagConsent(false);
    };

    if (!showConsent) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-slate-700 bg-opacity-70 z-50">
            <div className="fixed bottom-0 left-0 right-0 lg:flex items-center justify-between px-4 lg:px-20 py-4 lg:py-8 bg-gray-100">
                <span className="text-primary-dark text-base mr-16">
                    {translation.description}
                </span>
                <div className="flex justify-center my-4 lg:my-0">
                    <button
                        className="bg-primary w-40 h-12 py-2 px-8 rounded text-white mr-8"
                        onClick={() => declineCookie()}
                    >
                        {translation.declineButton}
                    </button>
                    <button
                        className="bg-primary w-40 h-12 py-2 px-8 rounded text-white"
                        onClick={() => acceptCookie()}
                    >
                        {translation.acceptButton}
                    </button>
                </div>
            </div>
        </div>
    );
};
